import { useState } from "react";
import { Button, Col, Glyphicon, Row } from "react-bootstrap";
import type { IDonorMentorCannedResponse } from "@nkr/models/dash/donor-mentor-canned-response";
import { DonorMentorCannedResponseApi } from "@nkr/models/dash/donor-mentor-canned-response";
import { DonorMentorCannedResponsesGrid } from "./donor-mentor-canned-responses-grid";
import { DonorMentorCannedResponsesSidebar } from "./donor-mentor-canned-responses-sidebar";

const EMPTY_CANNED_RESPONSE: IDonorMentorCannedResponse = {
    id: 0,
    name: "",
    emailSubject: "",
    emailContent: "",
};

const DonorMentorCannedResponses = () => {
    const [selectedRow, setSelectedRow] = useState<IDonorMentorCannedResponse | null>(null);
    const results = DonorMentorCannedResponseApi.useGetAll();

    return <>
        <Row style={{ margin: "12px 0" }}>
            <Col xs={6}><h3 style={{ margin: 0 }}>Donor Mentor Canned Responses</h3></Col>
            <Col xs={6} style={{ textAlign: "right" }}>
                <Button
                    bsStyle="primary"
                    onClick={() => setSelectedRow(EMPTY_CANNED_RESPONSE)}
                    style={{ marginLeft: 10 }}>
                    <Glyphicon glyph="plus" /> Add New
                </Button>
            </Col>
        </Row>

        {results?.isSuccess && results?.payload && (
            <DonorMentorCannedResponsesGrid data={results.payload} setSelectedRow={setSelectedRow} />
        )}

        {selectedRow && (
            <DonorMentorCannedResponsesSidebar selected={selectedRow} setSelectedRow={setSelectedRow} />
        )}
    </>;
};

export default DonorMentorCannedResponses;
